import api from "../axiosIntercepture";

const BASE = "courier-service";

export const createCourierService = async (payload) => {
  try {
    const response = await api.post(`${BASE}/create`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error creating courier service:", err);
    throw err?.response?.data?.message || "Failed to create courier service";
  }
};

export const getAllCourierServices = async () => {
  try {
    const response = await api.get(`${BASE}/get-all`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? [];
  } catch (err) {
    console.error("Error fetching courier services:", err);
    throw err?.response?.data?.message || "Failed to fetch courier services";
  }
};

export const getCourierServicesByCourier = async (courierId) => {
  try {
    const response = await api.get(`${BASE}/get-by-courier/${courierId}`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? [];
  } catch (err) {
    console.error("Error fetching courier services by courier:", err);
    throw err?.response?.data?.message || "Failed to fetch courier services";
  }
};

export const updateCourierService = async (id, payload) => {
  try {
    const response = await api.put(`${BASE}/update/${id}`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error updating courier service:", err);
    throw err?.response?.data?.message || "Failed to update courier service";
  }
};

export const deleteCourierService = async (id) => {
  try {
    const response = await api.delete(`${BASE}/delete/${id}`);
    if (response.data?.success) {
      return response.data.data;
    }
    return response.data;
  } catch (err) {
    console.error("Error deleting courier service:", err);
    throw err?.response?.data?.message || "Failed to delete courier service";
  }
};
